import { render } from "./DorseAyagi.vue?vue&type=template&id=f16d8dde"
import script from "./DorseAyagi.vue?vue&type=script&lang=js"
export * from "./DorseAyagi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__